<template lang="pug">
	.maps--map-screener-root
		.maps--map-screener(ref="screener", :style="{ top: `-${height}px` }")
			.screener-map-holder(ref="holder", :style="{ width: `${width}px`, height: `${height}px` }")
				.screener-map(:style="{ width: `${width}px`, height: `${height}px` }")
</template>

<script>
	import $ from 'jquery';
	import VueTypes from 'vue-types';
	import dynamic from 'dynamic';
	import html2canvas from 'html2canvas';

	export default {
		translationCategory: 'maps.MapScreener',
		name: 'maps--map-screener',
		props: {
			width: VueTypes.number.def(1920),
			height: VueTypes.number.def(1920),
			geoJsons: VueTypes.array.def([]),
			geoStyle: VueTypes.any.def(null)
		},
		data() {
			return {
			};
		},
		watch: {
		},
		mounted() {
			if (__DEBUG__)
				window.mapScreener = this;
			window.jQuery = $;
			dynamic.loadOnce([
				'https://unpkg.com/leaflet@1.5.1/dist/leaflet.js',
				'https://unpkg.com/leaflet@1.5.1/dist/leaflet.css',
			]).then(() => {
				return dynamic.loadOnce([
					'https://unpkg.com/leaflet.vectorgrid@latest/dist/Leaflet.VectorGrid.bundled.js'
				]).then(() => {
					if (__DEBUG__)
						console.debug('Map screener loaded');
					this.buildMap();
					this.generateScreen();
					return this.$map;
				});
			});
		},
		destroyed() {
			delete this.$map;
			if (this.$screener) {
				this.$el.appendChild(this.$screener);
				delete this.$screener;
			}
		},
		methods: {
			addFeatureGroupItems() {
				if (!this.featureGroup) return;
				this.featureGroup.clearLayers();
				if (this.featureGroupItems) {
					this.featureGroupItems.map(f => {
						f.addTo(this.featureGroup);
					});
				}
			},
			createLayers() {
				let getJsonDoc = {
					type: 'FeatureCollection',
					features: []
				};

				this.geoJsons.map(geoJson => {
					let feature = {
						type:"Feature",
						geometry: geoJson
					}
					getJsonDoc.features.push(feature);
				});

				if (this.$vectorGrid) {
					this.$vectorGrid.remove();
				}

				this.$zipsJson = getJsonDoc;
				const feature = L.geoJson(getJsonDoc);
				const bounds = feature.getBounds();
				
				this.$vectorGrid = L.vectorGrid.slicer(getJsonDoc, {
					rendererFactory: L.canvas.tile,
					tolerance: 10,
					vectorTileLayerStyles: {
						sliced: (properties, zoom) => {
							return this.geoStyle || {
								fillColor: '#eca035',
								fillOpacity: 0.45,
								stroke: true,
								fill: true,
								color: '#eca035',
								opacity: 1,
								weight: 1,
							};
						}
					},
					interactive: false
				}).addTo(this.$map);

				if (__DEBUG__)
					console.debug('createLayers', { getJsonDoc });

				return bounds;
			},
			buildMap() {
				if (__DEBUG__)
					console.log('Build map screener');

				const L = window.L;
				const map = this.$map = L.map($(this.$el).find('.screener-map')[0], {
					zoomControl: false
				});

				L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}@2x.png', {
					maxZoom: 18
				}).addTo(map);

				this.$map.getRenderer(this.$map).options.padding = 0;

				this.$screener = this.$refs.screener;
				document.body.appendChild(this.$screener);
			},
			generateScreen() {
				let rendered = false;
				const loaded = () => {
					if (this._isDestroyed || rendered || this.layersTilesLoading()) return;
					rendered = true;
					this.getLayers().map(l => l.off('load', loaded));
					setTimeout(() => {
						if (this._isDestroyed) return;
						html2canvas(this.$refs.holder, {
							useCORS: true,
							allowTaint: true,
						}).then(canvas => {
							if (__DEBUG__)
								console.debug('Html2Canvas result', canvas);
							this.$emit('image-generated', canvas.toDataURL('image/jpeg', 0.95));
						}).catch(() => this.$emit('image-generated', null));
					}, 1500);
				};

				const setBounds = (bounds) => {
					if (__DEBUG__)
						console.debug('Bounds changed', bounds);
					if (bounds.isValid && !bounds.isValid()) {
						this.$emit('image-generated', null);
						return;
					}
					this.$emit('start-generation');
					this.$emit('bounds-changed', bounds);
					this.$map.fitBounds(bounds);
					setTimeout(() => {
						if (this._isDestroyed) return;
						if (!this.layersTilesLoading())
							loaded();
						else
							this.getLayers().map(l => l.on('load', loaded));
					}, 500);
				};
				
				let bounds = this.createLayers();
				setBounds(bounds);
			},
			layersTilesLoading() {
				return this.getLayers().some(f => f._noTilesToLoad && !f._noTilesToLoad());
			},
			getLayers() {
				return Object.keys(this.$map._layers).map(k => this.$map._layers[k]);
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	
	.maps--map-screener {
		position: fixed;
	}
</style>
